import { BOX_SHADOWS, FONTS } from "../../constants";

import { createStyles, makeStyles, Theme } from "@material-ui/core";

import { stateTypeF } from "../../state";
import { Hist } from "../Common/Hist";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chartContainer: {
      width: "90%",
      marginLeft: "5%",
    },
    chartContainer2: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      backgroundColor: "white",
      boxShadow: BOX_SHADOWS,
      borderRadius: "10px",
    },
  })
);

function ChartXTitle({ xName }) {
  return (
    <div
      style={{
        color: "rgba(0,0,0,0.6)",
        fontFamily: FONTS,
        fontSize: "14px",
        zIndex: 1000,
        marginTop: "440px",
        marginBottom: "-440px",
        width: "100%",
        marginLeft: "40px",
        height: "0px",
        textAlign: "center",
      }}
    >
      {xName}
    </div>
  );
}

function ChartYTitle({ yName }) {
  let mrg = 170 + yName.length * 4 + "px";
  return (
    <div
      style={{
        color: "rgba(0,0,0,0.6)",
        fontFamily: FONTS,
        fontSize: "14px",
        zIndex: 100,
        transform: "rotate(-90deg)",
        height: "30px",
        width: "0px",
        marginTop: mrg,
        backgroundColor: "blue",
        marginRight: "-30px",
        marginLeft: "30px",
        whiteSpace: "nowrap",
      }}
    >
      {yName}
    </div>
  );
}

export function ChartTitle({ title }) {
  return (
    <div
      style={{
        color: "rgba(0,0,0,0.8)",
        fontFamily: FONTS,
        fontSize: "17px",
        zIndex: 1000,
        marginTop: "-30px",
        marginBottom: "30px",
        width: "100%",
        marginLeft: "40px",
        height: "0px",
        textAlign: "center",
      }}
    >
      {title}
    </div>
  );
}

type customHistType = {
  state: stateTypeF;
  histData: number[][];
  title: string;
  isCat: boolean;
};
export function FilterHistogram({
  state,
  histData,
  title,
  isCat = false,
}: customHistType) {
  const classes = useStyles();
  if (histData === undefined) {
    return <div></div>;
  }

  return (
    <div className={classes.chartContainer}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <ChartYTitle yName={"Counts"}></ChartYTitle>
        <div className={classes.chartContainer2}>
          <ChartTitle title={title}></ChartTitle>
          <ChartXTitle xName={"Bins"}></ChartXTitle>
          <Hist state={state} data={histData} isCat={isCat}></Hist>
        </div>
      </div>
    </div>
  );
}
